import React from 'react';
import {
  Container, Typography, Box, Paper, Divider, Link, Breadcrumbs
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import GavelIcon from '@mui/icons-material/Gavel';
import { Link as RouterLink } from 'react-router-dom';
import Footer from '../Footer/Footer';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import PeopleIcon from '@mui/icons-material/People';
const TermsOfService = () => {
  const lastUpdated = "April 17, 2025";

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Breadcrumbs navigation */}
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 3 }}>
        <Link
          component={RouterLink}
          to="/"
          sx={{ display: 'flex', alignItems: 'center', color: 'black' }}
        >
          <HomeIcon sx={{ mr: 0.5, }} fontSize="inherit" />
          Home
        </Link>
        <Link
          component={RouterLink}
          to="/terms"
          sx={{ display: 'flex', alignItems: 'center',}}
        >
          <GavelIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Terms of Service
        </Link>
        <Link
          component={RouterLink}
          to="/privacy"
          sx={{ display: 'flex', alignItems: 'center', color: 'black' }}
        >
          <PrivacyTipIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Privacy Policy
        </Link>
        <Link
          component={RouterLink}
          to="/guidelines"
          sx={{ display: 'flex', alignItems: 'center', color: 'black' }}
        >
          <PeopleIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Community Guidelines
        </Link>
      </Breadcrumbs>

      <Paper elevation={0} sx={{ p: 4, borderRadius: 2, mb: 6 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            Terms of Service
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Last Updated: {lastUpdated}
          </Typography>
        </Box>

        <Typography paragraph>
          Welcome to UnitedInTalk. Please read these Terms of Service ("Terms") carefully as they contain important information about your legal rights, remedies, and obligations. By accessing or using the UnitedInTalk platform, you agree to comply with and be bound by these Terms.
        </Typography>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, please do not access or use our platform.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            2. User Eligibility
          </Typography>
          <Typography paragraph>
            You must be at least 18 years old to use our services. By accessing or using our platform, you represent and warrant that you are at least 18 years of age and have the legal capacity to enter into these Terms.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            3. User Accounts and Registration
          </Typography>
          <Typography paragraph>
            When you create an account with us, you must provide accurate, complete, and current information. You are responsible for safeguarding your password and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
          </Typography>
          <Typography paragraph>
            We reserve the right to disable any user account if we believe you have violated any provisions of these Terms.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            4. User Conduct and Community Guidelines
          </Typography>
          <Typography paragraph>
            Our platform is dedicated to fostering civil conversation across political differences. You agree to:
          </Typography>
          <Box component="ul" sx={{ pl: 4 }}>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography>Engage respectfully with other users regardless of their political views</Typography>
            </Box>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography>Not engage in hate speech, harassment, or bullying</Typography>
            </Box>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography>Not impersonate another person or misrepresent your identity</Typography>
            </Box>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography>Not use our platform for illegal activities or to promote violence</Typography>
            </Box>
            <Box component="li">
              <Typography>Not interfere with or disrupt the operation of our services</Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            5. Content Standards
          </Typography>
          <Typography paragraph>
            You are responsible for all content you submit, post, or transmit through our platform. Content that violates any applicable law or regulation, or infringes upon the rights of others is prohibited.
          </Typography>
          <Typography paragraph>
            We reserve the right to remove any content that violates these Terms or that we find objectionable for any reason, without prior notice.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            6. Intellectual Property
          </Typography>
          <Typography paragraph>
            Our platform and its original content, features, and functionality are owned by ArcZen and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            7. Privacy Policy
          </Typography>
          <Typography paragraph>
            Our Privacy Policy, which explains how we collect, use, and share information about you, is incorporated into these Terms by reference. By using UnitedInTalk, you consent to our collection and use of personal data as outlined in our Privacy Policy.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            8. Disclaimer of Warranties
          </Typography>
          <Typography paragraph>
            OUR PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
          </Typography>
          <Typography paragraph>
            WE DO NOT GUARANTEE THAT OUR SERVICES WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE, OR THAT DEFECTS WILL BE CORRECTED.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            9. Limitation of Liability
          </Typography>
          <Typography paragraph>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL ARCZEN, ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS, OR AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICES.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            10. Indemnification
          </Typography>
          <Typography paragraph>
            You agree to indemnify, defend, and hold harmless ArcZen and its officers, directors, employees, agents, and affiliates from and against any claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) that arise from or relate to your violation of these Terms or your use of the platform.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            11. Termination
          </Typography>
          <Typography paragraph>
            We may terminate or suspend your account and access to our services immediately, without prior notice or liability, for any reason, including without limitation if you breach these Terms.
          </Typography>
          <Typography paragraph>
            All provisions of the Terms which by their nature should survive termination shall survive termination, including ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            12. Governing Law
          </Typography>
          <Typography paragraph>
            These Terms shall be governed by and construed in accordance with the laws of the United States of America, without regard to its conflict of law provisions.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            13. Changes to Terms
          </Typography>
          <Typography paragraph>
            We reserve the right to modify these Terms at any time. We will provide notice of any material changes by updating the "Last Updated" date at the top of these Terms. Your continued use of the platform after such modifications will constitute your acknowledgment and agreement to the modified Terms.
          </Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
            14. Contact Information
          </Typography>
          <Typography paragraph>
            For questions about these Terms, please contact us at team@arczen.com.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="subtitle1">
            By using UnitedInTalk, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
          </Typography>
        </Box>
      </Paper>
      
      <Footer/>
    </Container>
  );
};

export default TermsOfService;